<script setup>
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import authV2ForgotPasswordIllustrationDark from '@images/pages/auth-v2-forgot-password-illustration-dark.png'
import authV2ForgotPasswordIllustrationLight from '@images/pages/auth-v2-forgot-password-illustration-light.png'
import authV2MaskDark from '@images/pages/misc-mask-dark.png'
import authV2MaskLight from '@images/pages/misc-mask-light.png'
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'
import Logo from '@images/illustrations/sphiere_logo.png';

definePage({
  meta: {
    layout: "blank",
    unauthenticatedOnly: true,
  },
});


const email = ref('')
const authThemeImg = useGenerateImageVariant(authV2ForgotPasswordIllustrationLight, authV2ForgotPasswordIllustrationDark)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)
</script>

<template>
  <VRow class="auth-wrapper bg-surface" no-gutters>
    <VCol md="7" class="d-none d-md-flex" style="
        height: 100vh;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background:#232323;
        color: white;
        padding: 20px;
      ">

      <div class="d-flex align-center justify-center w-100 h-100">
        <VImg :src="Logo" style=" max-width: 300px; max-height: 200px;" />
      </div>


    </VCol>

    <VCol cols="12" md="5" class="auth-card-v2 d-flex align-center justify-center">
      <VCard flat :max-width="500" class="mt-12 mt-sm-0 pa-4">
        <VCardText>
          <!-- <VNodeRenderer :nodes="themeConfig.app.logo" class="mb-6" /> -->
          <h4 class="text-h4 mb-1">
            FORGOT PASSWORD?
          </h4>
          <p class="mb-0">
            Password Recovery
          </p>
        </VCardText>

        <VCardText>
          <VForm @submit.prevent="() => {}">
            <VRow>
              <!-- email -->
              <VCol cols="12">
                <AppTextField v-model="email" autofocus label="Email" placeholder="johndoe@email.com" type="email" />
              </VCol>

              <!-- Reset link -->
              <VCol cols="12">
                <VBtn block type="submit">
                  Send Reset Link
                </VBtn>
              </VCol>

              <!-- back to login -->
              <VCol cols="12">
                <RouterLink class="d-flex align-center justify-center" :to="{ name: 'pages-authentication-login-v2' }">
                  <VIcon icon="tabler-chevron-left" class="flip-in-rtl" />
                  <span>Back to login</span>
                </RouterLink>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
